import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  fetchInfo: null,
  recipe: null,
  convertSuccessful: null,
  saveSuccessful: false,
  deleteSuccessful: false,
  deleteError: null,
  deleteFetching: false,
  duplicateSuccessful: null,
  duplicateError: null,
  inactiveSuccessful: false,
  inactiveError: null,
  inactiveFetching: false,
  nutritionFactsFetching: false,
  showIngredientModal: false,
  newRecipeId: null,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.MANAGE_RECIPE_WRITE_INACTIVE_ERROR:
      return {
        ...state,
        inactiveError: payload,
      };

    case types.MANAGE_RECIPE_DELETE_RECIPE_ERROR:
      return {
        ...state,
        deleteError: payload,
      };
    case types.MANAGE_RECIPE_DUPLICATE_RECIPE_ERROR:
      return {
        ...state,
        duplicateError: payload,
      };
    case types.MANAGE_RECIPE_WRITE_INACTIVE_LOADING:
      return { ...state, inactiveFetching: payload };
    case types.MANAGE_RECIPE_DELETE_RECIPE_LOADING:
      return { ...state, deleteFetching: payload };
    case types.MANAGE_RECIPE_GET_NUTRITION_FACTS_FETCHING:
      return { ...state, nutritionFactsFetching: payload };
    case types.MANAGE_RECIPE_SET_INACTIVE_SUCCESSFUL:
      return {
        ...state,
        inactiveSuccessful: payload,
      };
    case types.MANAGE_RECIPE_SET_SAVE_SUCCESSFUL:
      return {
        ...state,
        saveSuccessful: payload,
      };
    case types.MANAGE_RECIPE_SET_DELETE_SUCCESSFUL:
      return {
        ...state,
        deleteSuccessful: payload,
      };
    case types.MANAGE_RECIPE_SET_DUPLICATE_SUCCESSFUL:
      return {
        ...state,
        duplicateSuccessful: payload,
      };
    case types.MANAGE_RECIPE_FETCH_SUCCESS:
      return {
        ...state,
        recipe: payload,
      };
    case types.MANAGE_RECIPE_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case types.MANAGE_RECIPE_FETCH_ERROR:
      let fetchError;
      if (Array.isArray(payload)) {
        fetchError = payload[0];
      } else {
        fetchError = payload;
      }

      return {
        ...state,
        fetchError,
      };

    case types.MANAGE_RECIPE_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: null,
      };

    case types.MANAGE_RECIPE_FETCH_INFO:
      let fetchInfo;
      if (Array.isArray(payload)) {
        fetchInfo = payload[0];
      } else {
        fetchInfo = payload;
      }

      return {
        ...state,
        fetchInfo,
      };

    case types.MANAGE_RECIPE_CLEAR_INFO:
      return {
        ...state,
        fetchInfo: null,
      };

    case types.MANAGE_RECIPE_SET_CONVERT_TO_INGREDIENT_SUCCESSFUL:
      return { ...state, convertSuccessful: payload };

    case types.MANAGE_RECIPE_SET_SHOW_INGREDIENT_MODAL:
      return {
        ...state,
        showIngredientModal: payload,
      };
    case types.MANAGE_RECIPE_SAVE_NEW_RECIPE_SUCCESS:
      return {
        ...state,
        newRecipeId: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/managerecipe/state/editrecipe/reducer.js